export default __webpack_public_path__ + "static/media/bg-search.493dec77.png";